import * as React from 'react';
import styled from 'styled-components';

interface Props {
  loading: boolean;
  children?: any;
  style?: React.CSSProperties;
  dim?: boolean;
  primaryColor?: string;
  secondaryColor?: string;
}

export const ViewportLoader: React.FC<Props> = (props) => {
  const { loading, children, style, primaryColor, secondaryColor } = props;
  const dim = props.dim === undefined ? true : props.dim;

  const customStyle =
    primaryColor && secondaryColor
      ? {
          borderTopColor: secondaryColor,
          borderRightColor: secondaryColor,
          borderBottomColor: secondaryColor,
          borderLeftColor: primaryColor,
        }
      : undefined;

  return (
    <Wrapper style={style}>
      {dim && loading && <Backdrop />}

      {loading && (
        <FixedCenter>
          <Spinner style={customStyle} />
        </FixedCenter>
      )}

      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: auto;
  height: auto;
  position: relative;
`;

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: ${({ theme }) => theme.index.priorityContentShadow};
`;

const FixedCenter = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 100;
`;

const Spinner = styled.div`
  font-size: 10px;
  width: 10em;
  height: 10em;
  border-radius: 50%;
  text-indent: -9999em;
  border-top: 1.1em solid
    ${({ theme }) => theme.colors.loaderSecondary || 'rgba(126, 206, 210, 0.4)'};
  border-right: 1.1em solid
    ${({ theme }) => theme.colors.loaderSecondary || 'rgba(126, 206, 210, 0.4)'};
  border-bottom: 1.1em solid
    ${({ theme }) => theme.colors.loaderSecondary || 'rgba(126, 206, 210, 0.4)'};
  border-left: 1.1em solid
    ${({ theme }) => theme.colors.loaderPrimary || 'rgba(126, 206, 210, 1)'};
  animation: load8 1.1s infinite linear;

  @keyframes load8 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default ViewportLoader;
